import { useEffect } from 'react';
import { IHotelInfo } from '../types/hotelTypes';

export const useNewRelic = (hotel?: IHotelInfo) => {
  useEffect(() => {
    if (hotel) {
      window.newrelic?.setCustomAttribute('hotelName', hotel.hotelName);
      window.newrelic?.setCustomAttribute('hotelId', hotel.hotelId);
    }
  }, [hotel]);
};
